"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";

const queryClient = new QueryClient();

export default function QueryProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Dark bottom-center pill, per the v2 design system. */}
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 2600,
          style: {
            background: "#232A31",
            color: "#FFFFFF",
            fontSize: 13,
            borderRadius: 9,
            padding: "10px 18px",
            boxShadow: "0 8px 24px rgba(35, 42, 49, 0.3)",
          },
          success: { icon: null },
          error: { icon: null },
        }}
      />
    </QueryClientProvider>
  );
}
